//Whenever change this file must touch the builder.js file to compile
const IFRAME_BASE_PATH = '/dist/iframe-63c4f863';
const CUSTOM_BASE_PATH = '/dist/custom';


// Base constants
const BASE_HOME_IMAGES_URLS = [
    '/templates/en-US/backend-engineer.html',
    '/templates/en-US/marketing-analyst.html',
    '/templates/en-US/marketing-analyst.html'
];

const BASE_HORIZONTAL_SLIDERS_DIFFERENT_IMAGES_URLS = [
    '/templates/en-US/senior-scrum-master.html',
    '/templates/en-US/frontend-developer.html',
    '/templates/en-US/radiologist.html',


];

 const defaultLocaleOptions = {
        'en-US': 'US English',
        'en-GB': 'UK English',
        'es-419': 'Español',
        'fr-FR': 'Français',
        'de-DE': 'Deutsch',
        'ja-JP': '日本語',
        'it-IT': 'Italiano',
        'pt-BR': 'Português (Br)',
        'zh-CN': '简体中文'
    };

    //This path map is for the alternate link in the meta
    const htmlToPathMap = {
        contactus: 'contactus',
        jobposting: 'generate-resume-from-job-posting',
        customcriteria: 'generate-resume-from-text',
        texttocoverletter: 'generate-coverletter',
        //readymadetemplates: 'resume-from-readymade-templates',
        //resumeatschecker: 'resume-ats-checker',
        faqs: 'faqs',
        pricing: 'pricing',
        privacypolicy: 'privacypolicy',
        terms: 'terms-and-conditions',
        sitemap: 'sitemap',
    };

    const supportedLocales = Object.keys(defaultLocaleOptions);


const BASE_HORIZONTAL_SLIDERS_EN_US_DIFFERENT_IMAGES_URLS = [
    '/templates/en-US/marketing-analyst.html',
    '/templates/en-US/sr-manager-of-software-engineering.html',
    '/templates/en-US/agile-coach.html',
    '/templates/en-US/assistant-professor.html',
    '/templates/en-US/auto-mechanic.html',
    '/templates/en-US/backend-engineer.html',
    '/templates/en-US/cybersecurity-specialist.html',
    '/templates/en-US/marketing-analyst.html',
    '/templates/en-US/director-of-software-engineering.html',
    '/templates/en-US/elementary-teacher.html',
    '/templates/en-US/entry-level-marketing-agent.html',
    '/templates/en-US/experienced-sales-professional.html',
    '/templates/en-US/family-nurse-practitioner.html',
    '/templates/en-US/frontend-developer.html',
    '/templates/en-US/fullstack-developer.html',
    '/templates/en-US/fullstack-java-software-engineer.html',
    '/templates/en-US/marketing-analyst.html',
    '/templates/en-US/kindergarten-teaching-assistant.html',
    '/templates/en-US/marketing-manager.html',
    '/templates/en-US/marketing-professional.html',
    '/templates/en-US/nurse-practitioner.html',
    '/templates/en-US/radiologist.html',
    '/templates/en-US/senior-scrum-master.html',
    '/templates/en-US/marketing-analyst.html',
    '/templates/en-US/senior-software-engineer.html',
    '/templates/en-US/software-engineer-intern.html',

    '/templates/en-US/sydney-thomas-resume.html',
];

const BASE_HORIZONTAL_SLIDERS_EN_GB_DIFFERENT_IMAGES_URLS = [
    '/templates/en-GB/senior-scrum-master.html',
    '/templates/en-GB/sr-manager-of-software-engineering.html',
    '/templates/en-GB/frontend-developer.html',
    '/templates/en-GB/radiologist.html',
    '/templates/en-GB/agile-project-manager.html',
    '/templates/en-GB/nursery-teaching-assistant.html',
    '/templates/en-GB/auto-mechanic.html',
    '/templates/en-GB/senior-scrum-master.html',
    '/templates/en-GB/primary-school-teacher.html',
    '/templates/en-GB/backend-engineer.html',
    '/templates/en-GB/cybersecurity-specialist.html',
    '/templates/en-GB/director-of-software-engineering.html',
    '/templates/en-GB/experienced-sales-professional.html',
    '/templates/en-GB/family-nurse-practitioner.html',
    '/templates/en-GB/fullstack-developer.html',
    '/templates/en-GB/lecturer.html',
    '/templates/en-GB/senior-scrum-master.html',
    '/templates/en-GB/marketing-analyst.html',
    '/templates/en-GB/marketing-manager.html',
    '/templates/en-GB/nurse-practitioner.html',
    '/templates/en-GB/senior-marketing-strategist.html',
    '/templates/en-GB/senior-software-engineer.html',
    '/templates/en-GB/software-engineer-intern.html',
    '/templates/en-GB/senior-scrum-master.html',
    '/templates/en-GB/software-engineer.html',
    '/templates/en-GB/sydney-thomas-cv.html',
    '/templates/en-GB/sales-and-marketing-representative.html'
];


const BASE_HORIZONTAL_SLIDERS_DE_DE_DIFFERENT_IMAGES_URLS = [
    '/templates/de-DE/senior-scrum-master.html',
    '/templates/de-DE/sr-manager-of-software-engineering.html',
    '/templates/de-DE/backend-engineer.html',
    '/templates/de-DE/business-analyst.html',
    '/templates/de-DE/certified-family-nurse-practitioner.html',
    '/templates/de-DE/director-of-software-engineering.html',
    '/templates/de-DE/elementary-teacher.html',
    '/templates/de-DE/senior-scrum-master.html',
    '/templates/de-DE/experienced-sales-professional.html',
    '/templates/de-DE/frontend-developer.html',
    '/templates/de-DE/fullstack-developer.html',
    '/templates/de-DE/junior-professor.html',
    '/templates/de-DE/kindergarten-teaching-assistant.html',
    '/templates/de-DE/lebenslauf-MS_u.html',
    '/templates/de-DE/lebenslauf-sydney-thomas.html',
    '/templates/de-DE/marketing-analyst.html',
    '/templates/de-DE/senior-scrum-master.html',
    '/templates/de-DE/marketing-assistent.html',
    '/templates/de-DE/marketing-manager.html',
    '/templates/de-DE/marketing-strategist.html',
    '/templates/de-DE/pflegefachkraft.html',
    '/templates/de-DE/radiologist.html',
    '/templates/de-DE/sales-manager.html',
    '/templates/de-DE/senior-scrum-master.html',
    '/templates/de-DE/scrum-master.html',
    '/templates/de-DE/senior-software-engineer.html',
    '/templates/de-DE/software-engineer-intern.html',
    '/templates/de-DE/auto-mechanic.html',
    '/templates/de-DE/software-engineer.html',

    '/templates/de-DE/technology-intern.html'
];

const BASE_HORIZONTAL_SLIDERS_FR_FR_DIFFERENT_IMAGES_URLS = [
    '/templates/fr-FR/agile-coach.html',
    '/templates/fr-FR/sr-manager-of-software-engineering.html',
    '/templates/fr-FR/assistant-marketing.html',
    '/templates/fr-FR/auto-mechanic.html',
    '/templates/fr-FR/backend-engineer.html',
    '/templates/fr-FR/cv-YW3d.html',
    '/templates/fr-FR/cybersecurity-specialist.html',
    '/templates/fr-FR/agile-coach.html',
    '/templates/fr-FR/director-of-software-engineering.html',
    '/templates/fr-FR/experienced-sales-professional.html',
    '/templates/fr-FR/frontend-developer.html',
    '/templates/fr-FR/fullstack-developer.html',
    '/templates/fr-FR/infirmier.html',
    '/templates/fr-FR/kindergarten-teaching-assistant.html',
    '/templates/fr-FR/lecturer.html',
    '/templates/fr-FR/marketing-analyst.html',
    '/templates/fr-FR/agile-coach.html',
    '/templates/fr-FR/marketing-manager.html',
    '/templates/fr-FR/marketing-professional.html',

    '/templates/fr-FR/nurse-practitioner.html',
    '/templates/fr-FR/primary-school-teacher.html',
    '/templates/fr-FR/radiologist.html',
    '/templates/fr-FR/sales-professional.html',
    '/templates/fr-FR/agile-coach.html',
    '/templates/fr-FR/senior-scrum-master.html',
    '/templates/fr-FR/senior-software-engineer.html',
    '/templates/fr-FR/software-engineer-intern.html',
    '/templates/fr-FR/software-engineer.html',

    '/templates/fr-FR/sydney-thomas-cv.html'
];
//positions 0, 7,16,23
const BASE_HORIZONTAL_SLIDERS_ES_419_DIFFERENT_IMAGES_URLS = [
    '/templates/es-419/agile-coach.html',
    '/templates/es-419/sr-manager-of-software-engineering.html',
    '/templates/es-419/marketing-analyst.html',
    '/templates/es-419/auto-mechanic.html',
    '/templates/es-419/marketing-manager.html',
    '/templates/es-419/auxiliar-de-mercadotecnia.html',
    '/templates/es-419/marketing-professional.html',
    '/templates/es-419/agile-coach.html',
    '/templates/es-419/backend-engineer.html',
    '/templates/es-419/practicante-mba.html',
    '/templates/es-419/primary-school-teacher.html',
    '/templates/es-419/curriculum-5MkL.html',
    '/templates/es-419/radiologist.html',
    '/templates/es-419/director-of-software-engineering.html',
    '/templates/es-419/sales-professional.html',
    '/templates/es-419/enfermera-laboral.html',
    '/templates/es-419/agile-coach.html',
    '/templates/es-419/senior-scrum-master.html',
    '/templates/es-419/experienced-sales-professional.html',
    '/templates/es-419/software-engineer-intern.html',
    '/templates/es-419/family-nurse-practitioner.html',
    '/templates/es-419/software-engineer.html',
    '/templates/es-419/frontend-developer.html',
    '/templates/es-419/agile-coach.html',
    '/templates/es-419/fullstack-developer.html',
    '/templates/es-419/sydney-thomas-cv.html',
    '/templates/es-419/ingeniero-de-software.html',
    '/templates/es-419/technology-intern.html',
    '/templates/es-419/kindergarten-teaching-assistant.html',
    '/templates/es-419/lecturer.html'
];
//positions 0, 7,16,23 agile-coach
const BASE_HORIZONTAL_SLIDERS_JA_JP_DIFFERENT_IMAGES_URLS = [
    '/templates/ja-JP/agile-coach.html',
    '/templates/ja-JP/assistant-professor.html',
    '/templates/ja-JP/auto-mechanic.html',
    '/templates/ja-JP/backend-engineer.html',
    '/templates/ja-JP/cv-p8k4.html',
    '/templates/ja-JP/director-of-software-engineering.html',
    '/templates/ja-JP/director-of-software-engineering2.html',
    '/templates/ja-JP/agile-coach.html',
    '/templates/ja-JP/elementary-teacher.html',
    '/templates/ja-JP/experienced-sales-professional.html',
    '/templates/ja-JP/family-nurse-practitioner.html',
    '/templates/ja-JP/frontend-developer.html',
    '/templates/ja-JP/fullstack-developer.html',
    '/templates/ja-JP/kindergarten-teaching-assistant.html',
    '/templates/ja-JP/marketing-analyst.html',
    '/templates/ja-JP/marketing-assistant-manager.html',
    '/templates/ja-JP/agile-coach.html',
    '/templates/ja-JP/marketing-manager.html',
    '/templates/ja-JP/marketing-professional.html',
    '/templates/ja-JP/mba-intern.html',
    '/templates/ja-JP/nurse-practitioner.html',
    '/templates/ja-JP/project-manager.html',
    '/templates/ja-JP/radiologist.html',
    '/templates/ja-JP/agile-coach.html',
    '/templates/ja-JP/sales-professional.html',
    '/templates/ja-JP/senior-software-engineer.html',
    '/templates/ja-JP/software-engineer-intern.html',
    '/templates/ja-JP/software-engineer.html',
    '/templates/ja-JP/sr-manager-of-software-engineering.html',
    '/templates/ja-JP/sydney-thomas-cv.html',
    '/templates/ja-JP/technology-intern.html'
];

const BASE_HORIZONTAL_SLIDERS_IT_IT_DIFFERENT_IMAGES_URLS = [
    '/templates/it-IT/agile-coach.html', // position 0
    '/templates/it-IT/sr-manager-of-software-engineering.html',
    '/templates/it-IT/assistant-professor.html',
    '/templates/it-IT/marketing-manager.html',
    '/templates/it-IT/assistente-marketing.html',
    '/templates/it-IT/marketing-professional.html',
    '/templates/it-IT/auto-mechanic.html',
    '/templates/it-IT/agile-coach.html', // position 7
    '/templates/it-IT/mba-intern.html',
    '/templates/it-IT/backend-engineer.html',
    '/templates/it-IT/primary-school-teacher.html',
    '/templates/it-IT/project-manager.html',
    '/templates/it-IT/curriculum-S5cZ.html',
    '/templates/it-IT/radiologist.html',
    '/templates/it-IT/director-of-software-engineering.html',
    '/templates/it-IT/sales-manager.html',
    '/templates/it-IT/agile-coach.html', // position 16
    '/templates/it-IT/director-of-software-engineering2.html',
    '/templates/it-IT/senior-software-engineer.html',
    '/templates/it-IT/experienced-sales-professional.html',
    '/templates/it-IT/software-engineer-intern.html',
    '/templates/it-IT/family-nurse-practitioner.html',
    '/templates/it-IT/software-engineer.html',
    '/templates/it-IT/agile-coach.html', // position 23
    '/templates/it-IT/frontend-developer.html',
    '/templates/it-IT/marketing-analyst.html',
    '/templates/it-IT/fullstack-developer.html',
    '/templates/it-IT/sydney-thomas-cv.html',
    '/templates/it-IT/infermiere-professionale.html',
    '/templates/it-IT/technology-intern.html',
    '/templates/it-IT/kindergarten-teaching-assistant.html'
];

const BASE_HORIZONTAL_SLIDERS_PT_BR_DIFFERENT_IMAGES_URLS = [
    '/templates/pt-BR/senior-scrum-master.html',                    // 0
    '/templates/pt-BR/frontend-developer.html',
    '/templates/pt-BR/radiologist.html',
    '/templates/pt-BR/agile-coach.html',
    '/templates/pt-BR/assistant-professor.html',
    '/templates/pt-BR/assistente-de-marketing.html',
    '/templates/pt-BR/auto-mechanic.html',
    '/templates/pt-BR/senior-scrum-master.html',                    // 7
    '/templates/pt-BR/backend-engineer.html',
    '/templates/pt-BR/primary-school-teacher.html',
    '/templates/pt-BR/curriculo-TzSx.html',
    '/templates/pt-BR/director-of-software-engineering.html',
    '/templates/pt-BR/engineering-director.html',
    '/templates/pt-BR/experienced-sales-professional.html',
    '/templates/pt-BR/family-nurse-practitioner.html',
    '/templates/pt-BR/fullstack-developer.html',
    '/templates/pt-BR/senior-scrum-master.html',                    // 16
    '/templates/pt-BR/kindergarten-teaching-assistant.html',
    '/templates/pt-BR/marketing-analyst.html',
    '/templates/pt-BR/marketing-manager.html',
    '/templates/pt-BR/marketing-professional.html',
    '/templates/pt-BR/mba-intern.html',
    '/templates/pt-BR/nurse-practitioner.html',
    '/templates/pt-BR/senior-scrum-master.html',                    // 23
    '/templates/pt-BR/sales-professional.html',
    '/templates/pt-BR/senior-software-engineer.html',
    '/templates/pt-BR/software-engineer-intern.html',
    '/templates/pt-BR/software-engineer.html',
    '/templates/pt-BR/sr-manager-of-software-engineering.html',
    '/templates/pt-BR/sydney-thomas-cv.html',
    '/templates/pt-BR/technology-intern.html'
];

const BASE_HORIZONTAL_SLIDERS_ZH_CN_DIFFERENT_IMAGES_URLS = [
    '/templates/zh-CN/agile-coach.html',
    '/templates/zh-CN/frontend-developer.html',
    '/templates/zh-CN/radiologist.html',
    '/templates/zh-CN/assistant-professor.html',
    '/templates/zh-CN/auto-mechanic.html',
    '/templates/zh-CN/backend-engineer.html',
    '/templates/zh-CN/primary-school-teacher.html',
    '/templates/zh-CN/agile-coach.html',
    '/templates/zh-CN/cv-TyCg.html',
    '/templates/zh-CN/director-of-software-engineering.html',
    '/templates/zh-CN/director-of-software-engineering2.html',
    '/templates/zh-CN/experienced-sales-professional.html',
    '/templates/zh-CN/family-nurse-practitioner.html',
    '/templates/zh-CN/fullstack-developer.html',
    '/templates/zh-CN/kindergarten-teaching-assistant.html',
    '/templates/zh-CN/marketing-analyst.html',
    '/templates/zh-CN/agile-coach.html',
    '/templates/zh-CN/marketing-assistant.html',
    '/templates/zh-CN/marketing-manager.html',
    '/templates/zh-CN/marketing-professional.html',
    '/templates/zh-CN/mba-intern.html',
    '/templates/zh-CN/nurse-practitioner.html',
    '/templates/zh-CN/sales-professional.html',
    '/templates/zh-CN/agile-coach.html',
    '/templates/zh-CN/scrum-master.html',
    '/templates/zh-CN/senior-software-engineer.html',
    '/templates/zh-CN/software-engineer-intern.html',
    '/templates/zh-CN/software-engineer.html',
    '/templates/zh-CN/sr-manager-of-software-engineering.html',
    '/templates/zh-CN/sydney-thomas-cv.html',
    '/templates/zh-CN/technology-intern.html'
];


const BASE_HORIZONTAL_SLIDERS_COVERLETTER_MAP = {
    'en-US': {
        'Elementary Teacher': '/templates/en-US/coverletters/elementary-teacher.html',
        'Software Engineering Intern': '/templates/en-US/coverletters/computer-science-student.html',
        'Director Software Engineering': '/templates/en-US/coverletters/director-software-engineering.html',
        'Entry Level Marketing Agent': '/templates/en-US/coverletters/entry-level-marketing-agent.html',
        'Nurse Practitioner': '/templates/en-US/coverletters/nurse-practitioner.html',
    },
    'en-GB': {
        'Software Engineer Intern': '/templates/en-GB/coverletters/computer-science-student.html',
        'Sales and Marketing Representative': '/templates/en-GB/coverletters/entry-level-marketing-agent.html',
        'Director of Software Engineering': '/templates/en-GB/coverletters/director-software-engineering.html',
        'Nurse Practitioner': '/templates/en-GB/coverletters/nurse-practitioner.html',
        'Primary School Teacher': '/templates/en-GB/coverletters/primary-school-teacher.html',
    },

    'de-DE': {
        'Praktikant Softwareentwicklung': '/templates/de-DE/coverletters/informatikstudent.html',
        'Marketing-Assistent': '/templates/de-DE/coverletters/marketing-assistent.html',
        'Leiter Softwareentwicklung': '/templates/de-DE/coverletters/director-software-engineering.html',
        'Pflegefachkraft': '/templates/de-DE/coverletters/pflegefachkraft.html',
        'Grundschullehrkraft': '/templates/de-DE/coverletters/lehrerin.html',
    },

    'fr-FR': {
        'Stagiaire en développement logiciel': '/templates/fr-FR/coverletters/computer-science-student.html',
        'Assistant Marketing': '/templates/fr-FR/coverletters/assistant-marketing.html',
        'Directeur en ingénierie logicielle': '/templates/fr-FR/coverletters/director-software-engineering.html',
        'Infirmier(ère) praticien(ne)': '/templates/fr-FR/coverletters/infirmier.html',
        'Enseignante en école primaire': '/templates/fr-FR/coverletters/enseignant.html',
    },

    'es-419': {
        'Maestra de preescolar, primaria e inglés': '/templates/es-419/coverletters/maestra-de-preescolar.html',
        'Becario de Ingeniería de Software': '/templates/es-419/coverletters/computer-science-student.html',
        'Auxiliar de Mercadotecnia': '/templates/es-419/coverletters/entry-level-marketing-agent.html',
        'Director de Ingeniería de Software': '/templates/es-419/coverletters/director-software-engineering.html',
        'Enfermera Profesional': '/templates/es-419/coverletters/nurse-practitioner.html',
    },

    'ja-JP': {
        '小学校教諭': '/templates/ja-JP/coverletters/elementary-teacher.html',
        'ソフトウェアエンジニア インターン': '/templates/ja-JP/coverletters/computer-science-student.html',
        'ソフトウェアエンジニアリング ディレクター': '/templates/ja-JP/coverletters/director-software-engineering.html',
        '看護師': '/templates/ja-JP/coverletters/nurse-practitioner.html',
        '営業・マーケティングアシスタントマネージャー': '/templates/ja-JP/coverletters/entry-level-marketing-agent.html',
    },


    'it-IT': {
        'Assistente Marketing e Commerciale': '/templates/it-IT/coverletters/assistente-marketing.html',
        'Sviluppatore junior': '/templates/it-IT/coverletters/studente-in-informatica.html',
        'Direttore Ingegneria del Software': '/templates/it-IT/coverletters/direttore-dell-ingegneria.html',
        'Infermiera': '/templates/it-IT/coverletters/infermiera.html',
        'Insegnante di Scuola Primaria': '/templates/it-IT/coverletters/insegnante-prevalente.html',
    },

    'pt-BR': {
        'Assistente de Marketing': '/templates/pt-BR/coverletters/assistente-de-marketing.html',
        'Estagiário em Engenharia de Software': '/templates/pt-BR/coverletters/computer-science-student.html',
        'Diretor de Engenharia de Software': '/templates/pt-BR/coverletters/diretor-de-engenharia-de-software.html',
        'Enfermeira Especializada': '/templates/pt-BR/coverletters/enfermeira.html',
        'Professor do Ensino Fundamental': '/templates/pt-BR/coverletters/professor-ensino-fundamental.html',
    },

    'zh-CN': {
        '市场助理': '/templates/zh-CN/coverletters/entry-level-marketing-agent.html',
        '软件工程实习生': '/templates/zh-CN/coverletters/computer-science-student.html',
        '软件工程总监': '/templates/zh-CN/coverletters/director-software-engineering.html',
        '护士': '/templates/zh-CN/coverletters/nurse-practitioner.html',
        '小学教师': '/templates/zh-CN/coverletters/elementary-teacher.html',
    },

};


















const BASE_HORIZONTAL_SLIDERS_SINGLE_ARRAY_IMAGES_URLS = [
    '/templates/en-US/radiologist.html'
];

const BASE_HORIZONTAL_SLIDERS_SINGLE_IMAGES_URL = '/dist/templates/default/6037a24ebdbd6/index.html';

//This 4 constants are in constants_module.js because of ES6 compatibility, from the contants_module
//they are used in template file - when you modify this also modify constants_module.js file
const GREEN_LEFT_TEMPLATE_CSS = `${IFRAME_BASE_PATH}/greenlefttemplate.css`;
const FONT_AWESOME_CSS = `${IFRAME_BASE_PATH}/fontawesome-free/css/all.min.css`;
const FONT_AWESOME_STYLE_CSS = `${IFRAME_BASE_PATH}/tinymce/plugins/fontawesomepicker/asset/style.css`;
const FONT_AWESOME_STYLE_FREE_CSS = `${IFRAME_BASE_PATH}/tinymce/plugins/fontawesomepicker/asset/style-free.css`;


const GREEN_LEFT_TEMPLATE_CSS_LINK = `<link href="${GREEN_LEFT_TEMPLATE_CSS}" rel="stylesheet">`;
const FONT_AWESOME_CSS_LINK = `<link href="${FONT_AWESOME_CSS}" rel="stylesheet">`;
const FONT_AWESOME_STYLE_CSS_LINK = `<link href="${FONT_AWESOME_STYLE_CSS}" rel="stylesheet">`;
const FONT_AWESOME_STYLE_FREE_CSS_LINK = `<link href="${FONT_AWESOME_STYLE_FREE_CSS}" rel="stylesheet">`;


//End of 4 constants


const JQUERY = `/dist/jquery/jquery.min.js`;
const BUILDER_IFRAME_CSS = `${IFRAME_BASE_PATH}/builder-frame.css`;
const JQUERY_UI_CSS = `/dist/jquery/css/jquery-ui.css`;
const SPLIDE_CSS = `${IFRAME_BASE_PATH}/splide/css/splide.min.css`;


// Export the constants for use in other files
export default {
    BASE_HOME_IMAGES_URLS,
    BASE_HORIZONTAL_SLIDERS_DIFFERENT_IMAGES_URLS,
    BASE_HORIZONTAL_SLIDERS_EN_US_DIFFERENT_IMAGES_URLS,
    BASE_HORIZONTAL_SLIDERS_EN_GB_DIFFERENT_IMAGES_URLS,
    BASE_HORIZONTAL_SLIDERS_DE_DE_DIFFERENT_IMAGES_URLS,
    BASE_HORIZONTAL_SLIDERS_FR_FR_DIFFERENT_IMAGES_URLS,
    BASE_HORIZONTAL_SLIDERS_SINGLE_ARRAY_IMAGES_URLS,
    BASE_HORIZONTAL_SLIDERS_ES_419_DIFFERENT_IMAGES_URLS,
    BASE_HORIZONTAL_SLIDERS_JA_JP_DIFFERENT_IMAGES_URLS,
    BASE_HORIZONTAL_SLIDERS_IT_IT_DIFFERENT_IMAGES_URLS,
    BASE_HORIZONTAL_SLIDERS_PT_BR_DIFFERENT_IMAGES_URLS,
    BASE_HORIZONTAL_SLIDERS_ZH_CN_DIFFERENT_IMAGES_URLS,
    BASE_HORIZONTAL_SLIDERS_COVERLETTER_MAP,
    BASE_HORIZONTAL_SLIDERS_SINGLE_IMAGES_URL,
    defaultLocaleOptions,
    htmlToPathMap,
    supportedLocales,
    GREEN_LEFT_TEMPLATE_CSS,
    BUILDER_IFRAME_CSS,
    JQUERY,
    JQUERY_UI_CSS,
    FONT_AWESOME_CSS,
    FONT_AWESOME_STYLE_CSS,
    FONT_AWESOME_STYLE_FREE_CSS,
    IFRAME_BASE_PATH,
    SPLIDE_CSS,
    GREEN_LEFT_TEMPLATE_CSS_LINK,
    FONT_AWESOME_CSS_LINK,
    FONT_AWESOME_STYLE_CSS_LINK,
    FONT_AWESOME_STYLE_FREE_CSS_LINK,

};